<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray" *ngIf="isErrorMessageDisplay"></app-sg-aria-message>
<h1>供給停止結果登録</h1>

<form [formGroup]="requestFormGroup" *ngIf="initResponse?.initialhyojiInfo && codeMap" (ngSubmit)="onClickButton('register')">
    <app-sgke340d-condition [codeMap]="codeMap" [initResponse]="initResponse"
        (onClickShishinButtonEvent)="onClickShishinBtn()"
        (onClickButtonEvent)="onClickButton($event)"></app-sgke340d-condition>
</form>